import { SBP_MIN_AMOUNT_RUBLES, WALLET_TOPUP_PAYMENT_METHODS } from 'modules/organizer/domain/constants/wallet-topup';
import { WalletTopupPaymentMethod } from 'modules/organizer/domain/interfaces/wallet-topup';
import * as yup from 'yup';

export interface WalletTopupFormValues {
  amount: number;
  paymentMethod: WalletTopupPaymentMethod;
}

export const walletTopupFormValidator = yup.object({
  amount: yup
    .number()
    .transform((value, original) => (original === '' || original === null ? undefined : Number(original)))
    .typeError('Введите сумму')
    .required('Введите сумму')
    .min(SBP_MIN_AMOUNT_RUBLES, `Минимальная сумма — ${SBP_MIN_AMOUNT_RUBLES} ₽`),
  paymentMethod: yup.string().oneOf([...WALLET_TOPUP_PAYMENT_METHODS], 'Выберите способ оплаты').required('Выберите способ оплаты'),
});

export interface BuyPlanFormValues {
  planId: number;
}

export const buyPlanFormValidator = yup.object({
  planId: yup.number().required('Выберите тариф').min(1, 'Выберите тариф'),
});
